import { Injectable } from '@angular/core';
import { BaseSearchStrategy } from './base-strategy';
import { SearchableItem } from '../models/searchable-item.model';
import {
  ScoredMatch,
  StrategyContext,
  StrategyId,
} from '../models/search-strategy.model';
import { stringSimilarity } from '../utils/fuzzy-search.utils';

@Injectable({ providedIn: 'root' })
export class FuzzyMatchStrategy extends BaseSearchStrategy {
  readonly id: StrategyId = 'fuzzy';
  readonly defaultWeight = 150;
  private readonly threshold = 0.5;

  override score<T>(
    item: SearchableItem<T>,
    ctx: StrategyContext
  ): ScoredMatch | null {
    const similarity = stringSimilarity(
      ctx.normalizedQuery,
      this.normalizedTitle(item)
    );
    if (similarity <= this.threshold) return null;
    return this.match(this.id, similarity * this.defaultWeight, `sim=${similarity.toFixed(2)}`);
  }
}
